
import { of as observableOf, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
/**
 * base API service
 *
 * provide : methods : PUT, PATCH, DELETE, GET, POST,...
 * @deprecated use ApiResourceService instead
 *
 */
//Vanilla
import _isString from 'lodash-es/isString';
import _get from 'lodash-es/get';
import _unset from 'lodash-es/unset';
import _merge from 'lodash-es/merge';
import _isUndefined from 'lodash-es/isUndefined';
import _isArray from 'lodash-es/isArray';
import _isObject from 'lodash-es/isObject';
import _isFinite from 'lodash-es/isFinite';
import _set from 'lodash-es/set';
import _keys from 'lodash-es/keys';
import _values from 'lodash-es/values';
import _join from 'lodash-es/join';
import _toString from 'lodash-es/toString';
import _split from 'lodash-es/split';
import _includes from 'lodash-es/includes';

import { Injectable } from '@angular/core';
import { ApiUrlService } from "../apiurl/apiurl.service";

//Service
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Import RxJs required methods

declare const xtoken;
declare const absUrl: string;
declare const userCompanyId: string;

@Injectable()
/**
 * @deprecated Use the new resource API
 */
export class ApiService extends ApiUrlService {

    //vars
    public response: any = {data: {}, display: {}};

    public m_prefix = sessionStorage.getItem("$instance_url");

    constructor(
        protected http: HttpClient
    ) {
        super();
    }

    // private m_apiUrl: any;


    /**
     * send To API
     *
     * to send data to a wenji API
     * @param {string} _name : name of the api, specified in apiUrlService
     * @param {any} _query : string or json object, depends of the method (get, post, ...) of the query
     * @param {any} _cb : callback function, launched after success
     */
    public sendToApi(_name: string,
                     _query?: any | string,
                     _storePath: string = '',
                     _canReplace: boolean = false): Observable<any> {
        const api: any = this.m_apiUrl[_name];

        const token: string = (typeof xtoken !== "undefined" && xtoken)
            || localStorage.getItem(`${this.prefix}_token`)
            || (typeof absUrl !== "undefined" && localStorage.getItem(`${absUrl}_token`));

        let contentType: string = 'application/json';
        if (_isString(_get(_query, 'query'))) {
            contentType = 'text/plain';
        }

        let headerObj: any = {
            'Content-Type': contentType,
            'xtoken': token,
            'Access-Control-Allow-Methods': "*"
        };

        // allow to unset the token in the header
        if (api.noToken) {
            _unset(headerObj, "xtoken");
        }

        if (api.additionalHeader) {
            headerObj = _merge(headerObj, api.additionalHeader);
        }

        if(api.useCompanyId && userCompanyId) {
            headerObj.company = userCompanyId;
        }

        const headers = new HttpHeaders(headerObj);

        // Create a request option
        const options = {headers};
        const vm: any = this;
        return vm[api.method](api, _query, options, _storePath, _canReplace);
    }


    public post(_api: any, _query: any | string, _options: any, _storePath: string = '') {

        const queryUrl = _isUndefined(_query.QUERY_URL) ? _query : _query.QUERY_URL;
        const queryBody = _isUndefined(_query.QUERY_BODY) ? _query : _query.QUERY_BODY;

        const url = this.constructUrl(_api, queryUrl);
        let storePath: string;

        if (_storePath !== '') {
            storePath = _storePath;
        } else {
            storePath = _api.storePath;
        }

        let body: any = {};

        if (queryBody.query && queryBody.urlPart) {
            if (!_isString(queryBody.query)) {
                body = JSON.stringify(queryBody.query);
            } else {
                body = queryBody.query;
            }
        } else {
            body = JSON.stringify(queryBody);
        }

        return this.http.post(url, body, _options).pipe(
            map((response: any) => {
                this.analyseSuccess(response);
                this.storeResult(response, storePath);
                return response;
            }));
    }

    /**
     * constructUrl
     *
     * functions to contruct url depending on api
     *
     * @param {any} _api: json object with all needed infos
     * @returns {string} _query: whole url
     */
    public constructUrl(_api: any, _query: any): string {

        let output: string;

        if (_isObject(_api.url)) {
            output = _api.url.before || "";

            if (_isString(_query) || _isFinite(_query)) {
                output += _query;
            }


            if (!_isString(_query) && _query.hasOwnProperty('urlPart')) {
                if (_isString(_query.urlPart)) {
                    output += _query.urlPart;
                } else if (_isObject(_query.urlPart)) {
                    //concat objets
                    const tempObj = _merge(_query.urlPart, _api.url);

                    //maybe need to sort obj

                    //gets array of values
                    const tempArray = _values(tempObj);

                    //array to string
                    output = _join(tempArray, '');
                }

            }

            if (_api.url.after) {
                output += _api.url.after;
            }

            /*
            url':{
                0 : "hotel/trips/",
                2 : "/properties/ ",
                4 : "/quotes"
            }

            sendToApi(
                1 : "htl_192072"
                3 : "HS_AFI_H_41328"
            )
            */

            // sendToApi('tripTruc', {urlPart : {1 : "htl_192072"  , 3 : "HS_AFI_H_41328"} } )

        } else {
            output = _api.url;
        }


        return output;
    }


    /**
     * storeResult
     *
     * Store results in service
     *
     * @param {any} _response        : data to store
     * @param {string} _storePath    : where to store
     * @param {boolean} _canReplace  : do I replace or not if data is steal
     */
    public storeResult(_response: any, _storePath: string, _canReplace: boolean = false): void {
        if (!_storePath) {
            return;
        }

        const tempObj: any = {};
        if (!this.response.data[_storePath]) {
            _set(this.response.data, _storePath, tempObj);
        }

        const responseObject = this.wrapData(_response.data);
        const key = _keys(responseObject)[0];
        const value = _values(responseObject)[0];
        _set(this.response.data[_storePath], _toString(key), value);

        this.additionalStore(responseObject, _storePath, _canReplace);
    }

    /**
     *  additionalStore
     *
     * to be overwrited in inherited services
     *
     * @param {any} _response        : data to store
     * @param {string} _storePath    : where to store
     * @param {boolean} _canReplace  : do I replace or not if data is steal
     */
    public additionalStore(_response: any, _storePath: string, _canReplace: boolean = false): void {
        //
    }

    /**
     *  wrapData
     *
     * to be overwrited in inherited services
     * in not overwrited, return _reponse
     *
     * @param {any} _response        : data to store
     */
    public wrapData(_responseData: any): any {
        return _responseData;
    }

    public handleError(_error: any,
                       _api: any,
                       _query: any,
                       _storePath: string = '',
                       _canReplace: boolean = false): Observable<any> {
        return observableOf(undefined);
    }

    public analyseSuccess(_response: any): any {
        let resp = _response._body;
        const htmlString = '}<br />';

        //test if there is htmlString in response, and transform it
        if (_includes(resp, htmlString)) {
            const arr = _split(resp, htmlString);
            resp = arr[0] + '}';
        }
        _response._body = resp;
    }

    public detectFalseSuccess(_response: any) {
//
    }


    private put(_api: any,
        _query: string | any,
        _options: any,
        _storePath: string = '',
        _canReplace: boolean = false): Observable<any> {

        const queryUrl = _isUndefined(_query.QUERY_URL) ? _query : _query.QUERY_URL;
        const queryBody = _isUndefined(_query.QUERY_BODY) ? _query : _query.QUERY_BODY;
        const url = this.constructUrl(_api, queryUrl);
        let storePath: string;

        if (_storePath !== '') {
            storePath = _storePath;
        } else {
            storePath = _api.storePath;
        }

        const body = JSON.stringify(queryBody);
        return this.http.put(url, body, _options).pipe(
            map((response: any) => {
                this.analyseSuccess(response);
                this.storeResult(response, storePath, _canReplace);
                return response;
            }),
            catchError((error: any): any => {
                return this.handleError(error, null, null);
            }));
    }

    private patch(_api: any,
        _query: string | any,
        _options: any,
        _storePath: string = '',
        _canReplace: boolean = false): Observable<any> {

        const url = this.constructUrl(_api, _query);
        let storePath: string;

        if (_storePath !== '') {
            storePath = _storePath;
        } else {
            storePath = _api.storePath;
        }

        const body = JSON.stringify(_query.query);

        return this.http.patch(url, body, _options).pipe(
            map((response: any) => {
                this.analyseSuccess(response);
                this.storeResult(response, storePath, _canReplace);
                return response;
            }),
            catchError((error: any): any => {
                return this.handleError(error, null, null);
            }));

    }

    private get(_api: any,
        _query: string,
        _options: any,
        _storePath: string = '',
        _canReplace: boolean = false): Observable<any> {

        const url = this.constructUrl(_api, _query);
        let storePath: string;

        if (_storePath !== '') {
            storePath = _storePath;
        } else {
            storePath = _api.storePath;
        }

        return this.http.get(url, _options).pipe(
            map((response: any): any | void => {
                this.analyseSuccess(response);
                if (_isArray(response.data) && response.data.length === 0) {
                    return 'fallBack';
                } else {
                    this.storeResult(response, storePath, _canReplace);
                    return { data: this.wrapData(response.data) };
                }
            }),
            catchError((error: any): any => {
                return this.handleError(error, _api, _query, _api.storePath, _canReplace);
            }));
    }



}
